module.exports = __webpack_public_path__ + "img/expodecor_rainbow.d5780021.jpg";